import React, { useRef, useState } from "react";

import { Link } from "react-router-dom";
import classnames from "classnames";
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { Tooltip } from "@mui/material";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import {
  FetchAxiosFile,
  FetchAxiosPut,
} from "../../api/axios";
import { useEffect } from "react";
import ConfirmModal from "../../components/Common/ConfirmModal";
import LoadingData from "../TESTPage/LoadingData";
import EvaluateFormHeader, { checkEvaluateScoreLevel, checkExpectLevel, EVALUATE_WEIGHT_NORMAL, getEvaluateWeight } from "./evaluateConfig";
import SpinerSubmit from "../../components/SpinerSubmit";

import { createBehaviorRows, shouldUseOldBehaviorRows } from "./shared/behaviorTemplate";
import { computeWeightedSum, computeBehaviorSum, toFullScore } from "./shared/scoreUtils";
import { saveBehaviorArray, saveDevelopmentArray } from "./shared/saveEvaluateArrays";
import { isFilledObjectArrayInsert, hasScoreOrderErrorInsert, submitErrorMessage } from "./shared/validators";
import { useApproveUserFlow } from "./shared/useApproveUserFlow";
import DevelopmentTopicSelect from "./components/DevelopmentTopicSelect";
import ApproveFlowCard from "./components/ApproveFlowCard";
import EvaLuateFormAlert from "./components/EvaLuateFormAlert";

const API_URL = process.env.REACT_APP_API_CORS;

function EvaluateForm(props) {
  const {
    user_id,
    evaluate_salary_id,
    budget_year,
    round,
    onButtonClick,
    approve_user_id,
    approve_user,
    user_department_id,
    version,
  } = props;
  // ใบประเมินปี 2569 รอบ 1 และปีก่อนหน้า ใช้สมรรถนะชุดเก่า
  const useOldBehaviorRows = shouldUseOldBehaviorRows(budget_year, round);
  const user = GetCookieData("userData")
  const token = GetCookieToken("userToken");
  const userPosition = GetCookieData("userPosition");
  const user_position =
    userPosition &&
    userPosition
      .sort((a, b) => a?.position_id - b?.position_id)
      ?.find((a) =>
        a?.position_id === 2
          ? 2
          : a?.position_id === 3
          ? 3
          : a?.position_id === 4
          ? 4
          : a?.position_id === 5
          ? 5
          : a?.position_id === 6
          ? 6
          : a?.position_id === 7
          ? 7
          : null
      )?.position_id;
  const tableWrapperRef = useRef(null);

  const [dataInfo, setDataInfo] = useState([]);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [activeTab, setactiveTab] = useState(1);
  const [link, setLink] = useState(null);
  const [approvID, setApprovID] = useState(null);
  const [approvUser, setApprovUser] = useState(null);
  const [approvOrg, setApprovOrg] = useState(null);
  const [alretFormOne, setAlretFormOne] = useState(false);
  const [alretFormTwo, setAlretFormTwo] = useState(false);
  const [alretFormFour, setAlretFormFour] = useState(false);
  const [chooseApprov, setChooseApprov] = useState([]);
  const [approveInfo, setApproveInfo] = useState([]);
  const [totalWeight, setTotalWeight] = useState(0);
  const [countSumWeight, setCountSumWeight] = useState(null);
  const [confirmModal, setconfirmModal] = useState(false)
  const [fileUploads, setFileUploads] = useState(
    Array.from({ length: 5 }, () => null)
  );
  const [task, setTask] = useState("")
  const [indexArrGrooup, setIndexArrGrooup] = useState([])
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpdateSuccess, setIsUpdateSuccess] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const [groups, setGroups] = useState([
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: 1 },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: 2 },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: 3 },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: 4 },
    { indicator: "", scores: ["", "", "", "", ""], score: "", weight: "", no: 5 },
  ]);

  const [formTwoData, setFormTwoData] = useState(() => createBehaviorRows(false, dataInfo?.user_level_id, useOldBehaviorRows));

  useEffect(() => {
    if (dataInfo?.user_level_id) {
      setFormTwoData(prev => createBehaviorRows(false, dataInfo.user_level_id, useOldBehaviorRows));
    }
  }, [dataInfo?.user_level_id, useOldBehaviorRows]);

  const [formTheeData_1, setFormTheeData_1] = useState({
    label: "องค์ประกอบที่ 1 : ผลสัมฤทธิ์ของงาน",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.first,
  });

  const [formTheeData_2, setFormTheeData_2] = useState({
    label: "องค์ประกอบที่ 2 : พฤติกรรมการปฏิบัติราชการ(สมรรถนะ)",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.second,
  });

  // น้ำหนักองค์ประกอบ: ปกติ 70/30 แต่ถ้า "ยังไม่ผ่านการทดลองงาน" (user_trial = 1) ใช้ 50/50
  useEffect(() => {
    const weight = getEvaluateWeight(dataInfo);
    setFormTheeData_1(prevData => ({ ...prevData, percentage: weight.first }));
    setFormTheeData_2(prevData => ({ ...prevData, percentage: weight.second }));
  }, [dataInfo?.user_trial]);

  const [formFourData, setFormFourData] = useState([
    { id: 1, topic: "", description: "" },
    { id: 2, topic: "", description: "" },
    { id: 3, topic: "", description: "" },
    { id: 4, topic: "", description: "" },
    { id: 5, topic: "", description: "" },
  ]);

  const [calculatedValues, setCalculatedValues] = useState([]);
  const [calculatedValuesForm2, setCalculatedValuesForm2] = useState([]);

  // ---- ลำดับผู้อนุมัติ (เดิมเป็น state+handler ~120 บรรทัด ย้ายไป shared hook) ----
  const {
    approveUserFlow,
    flowLoading,
    nextLvApproveName,
    handleChangeUser,
    handleAddUserFlow,
    handleRemoveUserFlow,
    handleEditFlow,
    resetFlow,
  } = useApproveUserFlow({
    evaluate_salary_id,
    budget_year,
    round,
    token,
    autoStart: true,
    initialValue: [],
  });

  const handleDevelopmentChange = (id, field, value) => {
    setFormFourData(prevData =>
      prevData.map(item =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const toggleTab = tab => {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  };

  const handleAddGroup = () => {
    setGroups(prevGroups => [
      ...prevGroups,
      {
        indicator: "",
        scores: ["", "", "", "", ""],
        score: "",
        weight: "",
        no: prevGroups.length + 1
      },
    ]);
  };

  const handleInputChange = (groupIndex, key, value) => {
    setGroups(prevGroups => {
      const updatedGroups = [...prevGroups];
      const groupToUpdate = updatedGroups[groupIndex];
      groupToUpdate[key] = value;
      updatedGroups[groupIndex] = groupToUpdate;
      return updatedGroups;
    });
  };

  useEffect(() => {
    const sum = computeWeightedSum(groups);
    setCalculatedValues(sum);
    setFormTheeData_1(prevData => ({
      ...prevData,
      score: toFullScore(sum),
    }));
  }, [groups]);

  useEffect(() => {
    const sum = computeBehaviorSum(formTwoData);
    setCalculatedValuesForm2(sum);
    setFormTheeData_2(prevData => ({
      ...prevData,
      score: toFullScore(sum),
    }));
  }, [formTwoData]);

  const handleScoreChange = (groupIndex, scoreIndex, value) => {
    setIndexArrGrooup((prev => [...prev.filter(x => x !== scoreIndex), scoreIndex]))
    setGroups(prevGroups => {
      const newGroups = [...prevGroups];
      newGroups[groupIndex].scores[scoreIndex] = value;
      return newGroups;
    });
  };

  const handleRemoveGroup = groupIndex => {
    setGroups(prevGroups =>
      prevGroups.filter((group, index) => index !== groupIndex)
    );
  };

  useEffect(() => {
    if (groups.some(
      i =>
        i.indicator !== "" &&
        i.scores[0] !== "" &&
        i.scores[1] !== "" &&
        i.scores[2] !== "" &&
        i.scores[3] !== "" &&
        i.scores[4] !== "" &&
        i.score !== "" &&
        i.weight !== ""
    )
    ) {
      setAlretFormOne(false);
    } else {
      setAlretFormOne(true);
    }

    if (formTwoData.some(i => i.score !== "")) {
      setAlretFormTwo(false);
    } else {
      setAlretFormTwo(true);
    }

    if (formFourData.some(i => i.id !== "" && i.topic !== "" && i.description !== "")) {
      setAlretFormFour(false);
    } else {
      setAlretFormFour(true);
    }
  }, [groups, formFourData, formTwoData])


  const submitEvaluate = async () => {
    const show_score = formTheeData_1.score !== "" && formTheeData_2.score !== "" ? isNaN(valScore.toFixed(4)) ? "0.0000" : valScore.toFixed(4) : "0.0000"
    const url = "/api/evaluateSalaryResult/array/save";

    const indicatorArray = groups.filter((item) => item.weight).map((item) => ({
      no: item.no,
      indicator: item.indicator,
      score_1: item.scores?.[0],
      score_2: item.scores?.[1],
      score_3: item.scores?.[2],
      score_4: item.scores?.[3],
      score_5: item.scores?.[4],
      score: item.score,
      weight: item.weight,
    }));

    if (indicatorArray.length > 0) {
      const payload = {
        evaluate_salary_id: evaluate_salary_id,
        user_id: user_id,
        budget_year: budget_year,
        round: round,
        indicatorArray: indicatorArray,
      };
    
      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: API_URL + url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      };

      try {
        const response = await axios.request(config);
        const result = response?.data?.results ?? [];
      
        for (const i of result) {
          if (i.success && i.no && i.insertedId) {
            const file = fileUploads[i.no - 1];
          
            if (file) {
              const url_file = `/api/evaluateSalaryResult/file/${i.insertedId}`;
              await FetchAxiosFile(url_file, token, file);
            }
          }
        }
      
        setAlretFormOne(false);
      } catch (error) {
        console.error(error);
      }
    } else {
      setAlretFormOne(true);
    }
    // บันทึกทั้งชุดในคำขอเดียวและ await ให้เสร็จก่อนไปอัปเดตสถานะใบประเมินด้านล่าง
    // (เดิม loop ยิงทีละแถวโดยไม่ await ทำให้บางแถวยังไม่ลงฐานข้อมูลตอนใบประเมินถูกส่ง)
    if (formTwoData.some(i => i.score !== "")) {
      await saveBehaviorArray(
        { evaluate_salary_id, user_id, budget_year, round, rows: formTwoData },
        token
      );
      setAlretFormTwo(false);
    } else {
      setAlretFormTwo(true);
    }

    if (formFourData.some(i => i.id !== "" && i.topic !== "" && i.description !== "")) {
      await saveDevelopmentArray(
        { evaluate_salary_id, user_id, budget_year, round, rows: formFourData },
        token
      );
      setAlretFormFour(false);
    } else {
      setAlretFormFour(true);
    }

    const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;

    let data = {
      user_id: user_id,
      budget_year: budget_year,
      status: 4,
      first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(4)}` : "0.0000",
      second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(4)}` : "0.0000",
      total_score: show_score,
      show_score: show_score
    };
    await FetchAxiosPut(url_submit, data, token);

    if (
      approveInfo.length !== 0 &&
      formFourData.some(
        i => i.id !== "" && i.topic !== "" && i.description !== ""
      ) &&
      formTwoData.some(
        i => i.id !== "" && i.topic !== "" && i.description !== ""
      ) &&
      groups.some(i => i.id !== "" && i.topic !== "" && i.description !== "")
    ) {
      let data = {
        user_id: user_id,
        budget_year: budget_year,
        status: 2,
        evaluate_url_ref: link,
        approve_user_id: approveInfo.user_id,
        approve_user: approveInfo.user_name,
        first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(4)}` : "0.0000",
        second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(4)}` : "0.0000",
        total_score: show_score,
        show_score: show_score,
      };
      await FetchAxiosPut(url_submit, data, token);
      onButtonClick();
    } else {
      if (
        formFourData.some(i => i.id !== "" && i.topic !== "" && i.description !== "") &&
        formTwoData.some(i => i.id !== "" && i.topic !== "" && i.description !== "") &&
        groups.some(i => i.id !== "" && i.topic !== "" && i.description !== "")
      ) {
        let data = {
          user_id: user_id,
          budget_year: budget_year,
          status: 2,
          evaluate_url_ref: link,
          approve_user_id: approvID,
          approve_user: approvUser,
          first_score: calculatedValues.length !== 0 ? `${(calculatedValues * (100 / 5)).toFixed(4)}` : "0.0000",
          second_score: calculatedValuesForm2.length !== 0 ? `${(calculatedValuesForm2 * (100 / 5)).toFixed(4)}` : "0.0000",
          total_score: show_score,
          show_score: show_score,
        };
        FetchAxiosPut(url_submit, data, token);
        onButtonClick();
      }
    }
  };

  // กันกดปุ่ม "ส่งแบบประเมิน" ซ้ำระหว่างที่ยังส่งไม่เสร็จ
  const handleSubmit = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    try {
      await submitEvaluate();
    } catch (error) {
      console.error(error);
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  const fetchPositionId = async (userid = null, next_org_lv = false, get_org = null) => {
    try {
      const url = `${API_URL}/api/users/position/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "position_id",
        "order[1]": "DESC",
        "filter[assign][0]": "0",
        "filter[user_id][0]": userid,
      });
      if (get_org) {
        params.append("filter[org_id][0]", get_org)
      }
      if (!userid) {
        params.delete("filter[user_id][0]", userid)
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };

      const response = await axios.get(url, config);
      if (response.data.result.length > 0) {
        const data = response.data.result.find(i => i.is_default);
        if (get_org) {
          return response.data.result
        } else if (next_org_lv) {
          if (data) {
            return data;
          } else if (response.data.result.length == 1) {
            return response.data.result
          }
        } else {
          if (data) {
            return data.position_id;
          } else if (response.data.result.length == 1) {
            return response.data.result.find(i => i.status == 1)?.position_id;
          }
        }
      } else {
        return 8;
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const handleDraft = async () => {
    setIsUpdateSuccess(null);
    try {
      setIsUpdate(true);

      const show_score = formTheeData_1.score !== "" && formTheeData_2.score !== "" ? isNaN(valScore.toFixed(4)) ? "0.00" : valScore.toFixed(4) : "0.00"

      const url = "/api/evaluateSalaryResult/array/save";

      const indicatorArray = groups.map((item) => ({
        no: item.no,
        indicator: item.indicator,
        score_1: item.scores?.[0],
        score_2: item.scores?.[1],
        score_3: item.scores?.[2],
        score_4: item.scores?.[3],
        score_5: item.scores?.[4],
        score: item.score,
        weight: item.weight,
      }));

      if (indicatorArray.length > 0) {
        const payload = {
          evaluate_salary_id: evaluate_salary_id,
          user_id: user_id,
          budget_year: budget_year,
          round: round,
          indicatorArray: indicatorArray,
        };

        const config = {
          method: "post",
          maxBodyLength: Infinity,
          url: API_URL + url,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: JSON.stringify(payload),
        };

        const response = await axios.request(config);
        const result = response?.data?.results ?? [];

        for (const i of result) {
          if (i.success && i.no && i.insertedId) {
            const file = fileUploads[i.no - 1];

            if (file) {
              const url_file = `/api/evaluateSalaryResult/file/${i.insertedId}`;
              await FetchAxiosFile(url_file, token, file);
            }
          }
        }

        setAlretFormOne(false);
      } else {
        setAlretFormOne(true);
      }

      // บันทึกทั้งชุดในคำขอเดียว ให้ server กำหนด step_active เอง
      // (เดิมยิงทีละแถวพร้อมกันด้วย step_active = version + 1 ที่คำนวณฝั่ง client
      //  ทำให้ได้ step_active ซ้ำกับรอบก่อนเมื่อ version ยังไม่ถูก refresh)
      await saveBehaviorArray(
        { evaluate_salary_id, user_id, budget_year, round, rows: formTwoData },
        token
      );

      await saveDevelopmentArray(
        { evaluate_salary_id, user_id, budget_year, round, rows: formFourData },
        token
      );

      const url_submit = `/api/evaluateSalary/${evaluate_salary_id}`;
      let data = {
        user_id: user_id,
        budget_year: budget_year,
        status: 1,
        evaluate_url_ref: link,
        show_score: show_score
      };
      await FetchAxiosPut(url_submit, data, token);

      setIsUpdate(false);
      setIsUpdateSuccess(true);
      onButtonClick();
    } catch (error) {
      console.error(error);
      setIsUpdate(false);
      setIsUpdateSuccess(false);
    }
  };

  const handleButtonFileClick = groupIndex => {
    const fileInput = document.getElementById(`file-input-${groupIndex}`);
    fileInput.click();
  };

  const handleFileChange = (e, groupIndex) => {
    const file = e.target.files[0];
    if (file.size > 1024 * 1024) {
      alert("ไฟล์ต้องมีขนาดไม่เกิน 1 MB");
      return;
    }
    const newFileUploads = [...fileUploads];
    newFileUploads[groupIndex] = file;
    setFileUploads(newFileUploads);
  };

  const handleClearFile = groupIndex => {
    const fileInput = document.getElementById(`file-input-${groupIndex}`);
    if (fileInput) {
      fileInput.value = null;

      const newFileUploads = [...fileUploads];
      newFileUploads[groupIndex] = null;
      setFileUploads(newFileUploads);
    }
  };

  let valScore =
    (Number(formTheeData_2.score) * Number(formTheeData_2.percentage)) / 100 +
    (Number(formTheeData_1.score) * Number(formTheeData_1.percentage)) / 100;

  useEffect(() => {
    const url = `${API_URL}/api/users/${user_id}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setDataInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (approve_user_id !== null && approve_user_id !== undefined) {
      const url = `${API_URL}/api/users/${approve_user_id}`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url, config)
        .then(response => {
          setApproveInfo(response.data.result);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, []);


  const OrgFuctionName = id => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[user_name_status][0]": "ปกติ",
      "filter[cont_to_id][0]": id,
    });
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setChooseApprov(prevChooseApprov => [
          ...prevChooseApprov,
          ...response.data.result,
        ]);
      })
      .catch(error => {
        console.error(error);
      });
  };

  useEffect(() => {
    const url_2 = `${API_URL}/api/orgInner/level`;
    const config_2 = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios.get(url_2, config_2).then(Res => {
      let foundItem = null;

      if (foundItem !== null) {
        Res.data.result.child?.forEach(i =>
          i.child?.forEach(item => {
            if (item.org_id === user_department_id) {
              foundItem = item.parent_id;
            }
          })
        );

        if (foundItem.length !== 0) {
          OrgFuctionName(foundItem);
          OrgFuctionName(user_department_id);
        } else {
          OrgFuctionName(user_department_id);
        }
      }
    });
  }, []);

  const handleSelectChange = event => {
    const selectedUserId = event.target.value;
    const selectedUserName =
      event.target.options[event.target.selectedIndex].text;
    setApprovID(selectedUserId);
    setApprovUser(selectedUserName);
    if (
      selectedUserId !== null &&
      selectedUserName !== null &&
      selectedUserId !== undefined &&
      selectedUserName !== undefined
    ) {
      const url = `${API_URL}/api/users/${selectedUserId}`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url, config)
        .then(response => {
          setApprovOrg(response.data.result);
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    let sum = 0;
    groups.forEach(group => {
      sum += parseFloat(Number(group.weight));
    });
    setTotalWeight(sum);
  }, [groups]);

  const [AcceptedgroupIndex, setAcceptedgroupIndex] = useState(null)
  const confrimModalDelete = async (groupIndex) => {
    setconfirmModal(true)
    setAcceptedgroupIndex(groupIndex)
  }

  useEffect(() => {
    if (groups !== null) {
      let count = 0;
      groups.filter(x => x.weight !== "" && x.weight !== null).map(i => {
        count = Number(i.weight) + count
      })
      setCountSumWeight(count)
    }
  }, [groups])

  const isFilledObjectArray = isFilledObjectArrayInsert;
  const hasScoreOrderError = () => hasScoreOrderErrorInsert(groups);

  const resolveApproveUserFlow = () => {
    let hasNormalApproveUser = approveUserFlow?.find(x => x.assessor === 0)
    let isPosition3And4 = [3, 4].includes(user_position)
    return !(hasNormalApproveUser || isPosition3And4)
  };

  const nextButtonDisable = (
    totalWeight < 100 ||
    activeTab === 4 ||
    Number(countSumWeight) > 100 ||
    (activeTab === 2 && formTwoData.some(item => item.score == "")) ||
    !isFilledObjectArray(groups) ||
    resolveApproveUserFlow() ||
    hasScoreOrderError()
  );

  const [submitError, setSubmitError] = useState(null);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);

  const validateAllTabs = () => {
    if (!isFilledObjectArray(groups)) {
      return { tab: 1, message: submitErrorMessage.evaluateResultCompletely };
    }
    if (Number(countSumWeight) !== 100) {
      return { tab: 1, message: submitErrorMessage.evaluateResultPercentage };
    }
    if (hasScoreOrderError()) {
      return { tab: 1, message: submitErrorMessage.targetLevalScoresOrder };
    }
    if (formTwoData.some((i) => i.score === "")) {
      return { tab: 2, message: submitErrorMessage.evaluateBehaviorCompletely };
    }
    if (!formFourData.some((i) => i.id !== "" && i.topic !== "" && i.description !== "")) {
      return { tab: 4, message: submitErrorMessage.evaluateDevelopmentCompletely };
    }

    return null;
  };

  const handleClickSubmit = () => {
    setHasAttemptedSubmit(true);
    const error = validateAllTabs();

    if (error) {
      setPassedSteps((prev) => Array.from(new Set([...prev, error.tab])));
      setactiveTab(error.tab);
      setSubmitError(error.message);
      return;
    }

    setSubmitError(null);
    setTask("SUBMIT");
    setconfirmModal(true);
  };

  useEffect(() => {
    if (!hasAttemptedSubmit) return;

    const error = validateAllTabs();
    setSubmitError(error ? error.message : null);
  }, [groups, countSumWeight, formTwoData, formFourData, hasAttemptedSubmit]);

  const handleSwapNo = (currentIndex, direction) => {
  const targetIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;

  if (targetIndex < 0 || targetIndex >= groups.length) return;

  setGroups((prev) => {
    const updated = [...prev];

    [updated[currentIndex], updated[targetIndex]] = [
      updated[targetIndex],
      updated[currentIndex],
    ];

    return updated.map((item, idx) => ({
      ...item,
      no: idx + 1,
    }));
  });

  // สลับไฟล์ที่แนบใหม่ (ถ้ามี) ให้ตามไปกับ item ที่ย้ายตำแหน่งด้วย
  // ใช้ currentIndex/targetIndex (0-based) ให้ตรงกับที่ fileUploads ใช้ groupIndex อ้างอิงอยู่ทุกที่ (upload, clear, render)
  setFileUploads((prev) => {
    const updated = [...prev];
    [updated[currentIndex], updated[targetIndex]] = [
      updated[targetIndex],
      updated[currentIndex],
    ];
    return updated;
  });
};

  return (
    <Container fluid>
      <Row className="mt-4">
        <Col lg={5}>
          <Card>
            <CardBody style={{ minHeight: "120px" }}>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong style={{ whiteSpace: "nowrap" }}>ผู้รับการประเมิน :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>{dataInfo.user_name}</strong>
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> ตำแหน่ง :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>{dataInfo.user_position_name}</strong>
                </Col>
              </Row>
              <Row>
                <Col className="text-end" xs={4} md={2} lg={3}>
                  <strong> สังกัด :</strong>
                </Col>
                <Col xs={8} md={10} lg={9}>
                  <strong>
                    {dataInfo.cont_to !== undefined ? (
                      <>{dataInfo.cont_to[0]?.org_name}</>
                    ) : (
                      ""
                    )}
                  </strong>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col lg={7}>
          <ApproveFlowCard
            flowLoading={flowLoading}
            approveUserFlow={approveUserFlow}
            editable={true}
            onChangeUser={handleChangeUser}
            onRemove={handleRemoveUserFlow}
            onAdd={handleAddUserFlow}
            onSave={handleEditFlow}
            onReset={resetFlow}
            loadingProps={{ width: 100, height: 60 }}
            cardBodyStyle={{ minHeight: "120px" }}
          />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <div className="wizard clearfix">
                <div className="steps clearfix">
                  <ul>
                    <NavItem className={classnames({ current: activeTab === 1 })}>
                      <NavLink style={{ border: activeTab === 1 ? "2px solid #0d6efd" : "" }} className={`${classnames({ current: activeTab === 1 })} h-100`} onClick={() => { setactiveTab(1) }} disabled={!(passedSteps || []).includes(1)}>
                        <Row className="mb-2">
                          <Col lg={2}>
                            <span className="number">1.</span>
                          </Col>
                          <Col lg={10}>แบบประเมินผลสัมฤทธิ์ของงาน</Col>
                        </Row>

                        <Row>
                          <Col lg={2}></Col>
                          <Col lg={10}>
                            <Col>
                              คะแนนรวม :{" "}
                              <Badge color="info" className="ms-2">
                                <h4 className="m-0">
                                  {calculatedValues.length !== 0
                                    ? `${isNaN((calculatedValues * (100 / 5)).toFixed(4)) ? "0.0000" : (calculatedValues * (100 / 5)).toFixed(4)}`
                                    : "0.0000"}
                                </h4>
                              </Badge>
                            </Col>
                          </Col>
                        </Row>
                      </NavLink>
                    </NavItem>
                    <NavItem className={classnames({ current: activeTab === 2 })}>
                      <NavLink style={{ backgroundColor: "rgba(161,238,189,0.5)", border: activeTab === 2 ? "2px solid #1EB053" : "" }} className={`${classnames({ active: activeTab === 2 })} h-100`} onClick={() => { setactiveTab(2) }} disabled={!(passedSteps || []).includes(2)}>
                        <Row className="mb-2">
                          <Col lg={2}>
                            <span className="number2">2.</span>
                          </Col>
                          <Col lg={10}>
                            แบบประเมินพฤติกรรมการปฏิบัติราชการหรือสมรรถนะ
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2}></Col>
                          <Col lg={10}>
                            <Col>
                              คะแนนรวม :{" "}
                              <Badge color="info" className="ms-2">
                                <h4 className="m-0">
                                  {calculatedValuesForm2.length !== 0
                                    ? `${isNaN((calculatedValuesForm2 * (100 / 5)).toFixed(4)) ? "0.0000" : (calculatedValuesForm2 * (100 / 5)).toFixed(4)}`
                                    : "0.0000"}
                                </h4>
                              </Badge>
                            </Col>
                          </Col>
                        </Row>
                      </NavLink>
                    </NavItem>
                    <NavItem className={classnames({ current: activeTab === 3 })}>
                      <NavLink style={{ backgroundColor: "rgba(255,190,125,0.5)", border: activeTab === 3 ? "2px solid #EA7603" : "" }} className={`${classnames({ active: activeTab === 3 })} h-100`} onClick={() => { setactiveTab(3) }} disabled={!(passedSteps || []).includes(3)}>
                        <Row className="mb-2">
                          <Col lg={2}>
                            <span className="number3">3.</span>
                          </Col>
                          <Col lg={10}>แบบสรุปการประเมินผลการปฏิบัติราชการ</Col>
                        </Row>
                        <Row>
                          <Col lg={2}></Col>
                          <Col lg={10}>
                            <Col lg={12} className="mb-2">
                              คะแนนรวม :{" "}
                              <Badge color="info" className="ms-2">
                                <h4 className="m-0">
                                  {formTheeData_1.score !== "" &&
                                    formTheeData_2.score !== ""
                                    ? isNaN(valScore.toFixed(4)) ? "0.0000" : valScore.toFixed(4)
                                    : "0.0000"}
                                </h4>
                              </Badge>
                            </Col>
                            <Col lg={12} className="d-flex justify-content-end">
                              <Badge color="primary">
                                <strong className="p-2" style={{ fontSize: "1.3rem" }}>{checkEvaluateScoreLevel(valScore)}</strong>
                              </Badge>
                            </Col>
                          </Col>
                        </Row>
                      </NavLink>
                    </NavItem>
                    <NavItem className={classnames({ current: activeTab === 4 })}>
                      <NavLink style={{ backgroundColor: "rgba(246,214,214,0.5)", border: activeTab === 4 ? "2px solid #F54B4B" : "" }} className={`${classnames({ active: activeTab === 4 })} h-100`} onClick={() => { setactiveTab(4) }} disabled={!(passedSteps || []).includes(4)}>
                        <Row className="mb-2">
                          <Col lg={2}>
                            <span className="number4">4.</span>
                          </Col>
                          <Col lg={10}>แผนพัฒนาการปฏิบัติราชการรายบุคคล</Col>
                        </Row>
                        <Row>
                          <Col lg={2}></Col>
                          <Col lg={10}>
                            <div style={{ paddingBottom: "7px" }} />
                            <strong className="fs-5">เรียงลำดับจากมากไปน้อย</strong>
                          </Col>
                        </Row>
                      </NavLink>
                    </NavItem>
                  </ul>
                </div>
                <div className="mb-2" ref={tableWrapperRef} style={{ position: "relative" }}>
                  <TabContent activeTab={activeTab} className="body">
                    <TabPane tabId={1}>
                      <Table bordered responsive>

                        <EvaluateFormHeader mode={'INSERT'} />

                        <tbody>
                          {groups.map((group, groupIndex) => (
                            <tr key={groupIndex}>
                              <td className="text-center">
                                <div className="d-flex flex-column align-items-center gap-1">
                                  <span className="fw-bold mb-1">{groupIndex + 1}</span>
                                  <div
                                    className="d-flex flex-column border rounded overflow-hidden"
                                    style={{ width: 32 }}
                                  >
                                    {!(groupIndex === 0) && <Button
                                      title="เลื่อนขึ้น"
                                      color="light"
                                      className="border-0 rounded-0 py-1"
                                      style={{ borderBottom: "1px solid #dee2e6" }}
                                      onClick={() => handleSwapNo(groupIndex, "up")}
                                    >
                                      <i className="fa-solid fa-chevron-up text-secondary" style={{ fontSize: 12 }} />
                                    </Button>}
                                    {!(groupIndex === groups.length - 1) && <Button
                                      title="เลื่อนลง"
                                      color="light"
                                      className="border-0 rounded-0 py-1"
                                      onClick={() => handleSwapNo(groupIndex, "down")}
                                    >
                                      <i className="fa-solid fa-chevron-down text-secondary" style={{ fontSize: 12 }} />
                                    </Button>}
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "250px" }}>
                                <Input
                                  style={{ height: "100px" }}
                                  type="textarea"
                                  name={`indicator_${groupIndex}`}
                                  value={group.indicator}
                                  onChange={e =>
                                    handleInputChange(
                                      groupIndex,
                                      "indicator",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              {group.scores.map((score, scoreIndex) => {
                                let thisScore = score
                                const prevValue = scoreIndex > 0 ? group.scores?.[scoreIndex - 1] ?? 0 : 0;

                                const isValid = (thisScore <= prevValue) && (thisScore > 0)
                                return (<td
                                  style={{ width: "100px" }}
                                  className="text-center"
                                  key={scoreIndex}
                                >
                                  <Input
                                    className={`text-center ${isValid ? "border border-danger border-2" : ""}`}
                                    type="text"
                                    id="scores"
                                    value={thisScore}
                                    onChange={e => {
                                      let numericValue = e.target.value.replace(/[^0-9]/g, "");
                                      numericValue = numericValue === "" ? 0 : parseInt(numericValue, 10);
                                      if (numericValue > 100) numericValue = 100;
                                      handleScoreChange(
                                        groupIndex,
                                        scoreIndex,
                                        numericValue
                                      );
                                    }}
                                    onBlur={e => {
                                      let numericValue = e.target.value.replace(/[^0-9]/g, "");
                                      numericValue = numericValue === "" ? 0 : parseInt(numericValue, 10);
                                      if (scoreIndex > 0 && numericValue < prevValue) {
                                        numericValue = prevValue;
                                      }
                                      if (scoreIndex > 0 && numericValue < prevValue) {
                                        numericValue = prevValue;
                                      }
                                      handleScoreChange(
                                        groupIndex,
                                        scoreIndex,
                                        numericValue
                                      );
                                    }}
                                  />
                                  {isValid && <span className="text-danger">ห้ามน้อยกว่าหรือเท่ากับก่อนหน้า</span>}
                                </td>)
                              }
                              )}
                              <td
                                style={{ width: "100px" }}
                                className="text-center"
                                name={`score_${groupIndex}`}
                              >
                                <Input
                                  maxlength={4}
                                  type="text"
                                  id="score"
                                  className="text-center"
                                  value={isNaN(group.score) ? "" : group.score}
                                  onChange={(e) => {
                                    let value = e.target.value;
                                    if (!/^\d*\.?\d*$/.test(value)) return;
                                    if (value === "") {
                                      handleInputChange(groupIndex, "score", "");
                                      return;
                                    }
                                    let num = parseFloat(value);
                                    if (isNaN(num)) {
                                      handleInputChange(groupIndex, "score", value);
                                      return;
                                    }
                                    if (num > 5) return;
                                    handleInputChange(groupIndex, "score", value);
                                  }}
                                  onBlur={() => {
                                    if (group.score !== "" && !isNaN(group.score)) {
                                      handleInputChange(
                                        groupIndex,
                                        "score",
                                        Number(group.score).toFixed(2)
                                      );
                                    }
                                  }}
                                />
                              </td>
                              <td
                                style={{ width: "120px" }}
                                className="text-center"
                                name={`weight_${groupIndex}`}
                              >
                                <Input
                                  type="text"
                                  id="weight"
                                  className={`text-center ${((totalWeight < 100 && totalWeight !== 0) || Number(countSumWeight) > 100) ? "border border-danger border-2" : ""}`}
                                  maxLength={
                                    group.weight !== null && group.weight < 10
                                      ? 4
                                      : group.weight >= 10 && group.weight < 100
                                        ? 5
                                        : Number(group.weight) === 100
                                          ? 6
                                          : undefined
                                  }
                                  value={isNaN(group.weight) ? "" : group.weight}
                                  onChange={e => {
                                    let value = e.target.value;
                                    if (value === "0") {
                                      value = "1"
                                    }
                                    if (value === "") {
                                      handleInputChange(groupIndex, "weight", "");
                                      return;
                                    }
                                    if (!/^\d+$/.test(value)) return;
                                    let num = parseInt(value, 10);
                                    if (num > 100) num = 100;
                                    handleInputChange(groupIndex, "weight", num);
                                  }}
                                />

                              </td>
                              <td className="text-center pb-2">
                                {group.weight !== "" && group.score !== "" ? (
                                  <strong>
                                    {isNaN(((group.weight * group.score) / 100).toFixed(4)) ? "" : ((group.weight * group.score) / 100).toFixed(4)}
                                  </strong>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td className="text-center">
                                <Col lg={12}>
                                  <FormGroup>
                                    <Button
                                      color="success"
                                      className="w-75 text-center"
                                      type="button"
                                      onClick={() => handleButtonFileClick(groupIndex)}
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      <i className="fa-solid fa-upload"></i>
                                    </Button>
                                    <input
                                      id={`file-input-${groupIndex}`}
                                      type="file"
                                      accept=".docx,.pdf"
                                      style={{ display: "none" }}
                                      onChange={e =>
                                        handleFileChange(e, groupIndex)
                                      }
                                    />
                                  </FormGroup>
                                  {fileUploads[groupIndex] !== null &&
                                    fileUploads[groupIndex] !== undefined ? (
                                    (() => {
                                      const file_type = fileUploads[groupIndex]?.name?.split('.')[1]
                                      const file_style = (file_type === "pdf") ? "secondary" : (file_type === "doc" || file_type === "docx") ? "info" : "secondary"

                                      return (
                                        <Row className="align-items-center">
                                          <Col lg={6}>
                                            <i className={`fa-solid fa-file-${file_type === "docx" ? "doc" : file_type} fa-2xl fa-beat text-${file_style}`}></i>
                                          </Col>
                                          <Col lg={6}>
                                            <button
                                              type="button"
                                              className={`btn btn-link btn-sm text-${file_style}`}
                                              onClick={() => {
                                                handleClearFile(groupIndex);
                                              }}
                                            >
                                              <i className="fa-solid fa-xmark-large"></i>
                                            </button>
                                          </Col>
                                        </Row>
                                      )
                                    })()
                                  ) : (
                                    ""
                                  )}
                                </Col>
                              </td>
                              <td>
                                <Button
                                  color="danger"
                                  onClick={() => {
                                    setTask("DELETE")
                                    confrimModalDelete(groupIndex)
                                  }}
                                >
                                  <i className="fa-solid fa-trash" />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Row>
                        <Col lg={4}>
                          <Button color="primary" onClick={handleAddGroup}>
                            เพิ่ม
                          </Button>
                        </Col>
                      </Row>
                      <InputGroup className="my-2">
                        <Input placeholder="link เอกสารเพิ่มเติม" onChange={e => setLink(e.target.value)} />
                        <Button color="primary">
                          <Link target="_blank" to={link} style={{ color: "#ffffff" }}>
                            <i className="fa-solid fa-earth-americas"></i>
                          </Link>
                        </Button>
                      </InputGroup>
                    </TabPane>
                    <TabPane tabId={2}>
                      <Table bordered responsive>
                        <thead
                          className="table-light"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <tr>
                            <th className="text-center">สมรรถนะ</th>
                            <th>ระดับที่คาดหวัง</th>

                            <th className="text-center">
                              คะแนน
                              <br />
                              (ก)
                            </th>
                            <th rowSpan="2" className="text-center">
                              น้ำหนัก
                              <br />
                              ร้อยละ
                              <br />
                              (ข)
                            </th>
                            <th rowSpan="2" className="text-center">
                              คะแนนรวม
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {formTwoData.map(item => (
                            <tr key={item.id}>
                              <td>{item.label}</td>
                              <td
                                className="text-center"
                                style={{ width: "150px" }}
                              >
                                {checkExpectLevel(dataInfo.user_level_id)}
                              </td>
                              <td style={{ width: "100px" }}>
                                <Input
                                  maxLength={4}
                                  type="text"
                                  className={`text-center ${item.score === "" ? "border border-danger border-2" : ""}`}
                                  value={item.score === "" || item.score === null ? "" : item.score}
                                  onChange={e => {
                                    let value = e.target.value;
                                    if (value === "") {
                                      setFormTwoData(prev =>
                                        prev.map(p =>
                                          p.id === item.id ? { ...p, score: "" } : p
                                        )
                                      );
                                      return;
                                    }
                                    if (!/^\d*\.?\d*$/.test(value)) return;

                                    let num = parseFloat(value);
                                    if (num > 5) return;
                                    if (isNaN(num)) {
                                      setFormTwoData(prev =>
                                        prev.map(p =>
                                          p.id === item.id ? { ...p, score: value } : p
                                        )
                                      );
                                      return;
                                    }
                                    if (num > 5) num = 5;
                                    const [i, d] = value.split(".");
                                    if (d && d.length > 2) {
                                      value = `${i}.${d.slice(0, 2)}`;
                                    }

                                    setFormTwoData(prev =>
                                      prev.map(p =>
                                        p.id === item.id
                                          ? { ...p, score: value }
                                          : p
                                      )
                                    );
                                  }}
                                  onBlur={() => {
                                    setFormTwoData(prev =>
                                      prev.map(p =>
                                        p.id === item.id
                                          ? {
                                            ...p,
                                            score:
                                              p.score === "" || isNaN(p.score)
                                                ? "0.00"
                                                : Number(p.score).toFixed(2),
                                          }
                                          : p
                                      )
                                    );
                                  }}
                                />
                              </td>
                              <td
                                className="text-center"
                                style={{ width: "150px" }}
                              >
                                ร้อยละ {item.percentage}
                              </td>
                              <td className="text-center" style={{ width: "150px" }}>
                                {item.score !== "" ?
                                  isNaN(((item.score * item.percentage) / 100).toFixed(4)) ? "0.0000"
                                    : ((item.score * item.percentage) / 100).toFixed(4)
                                  : ""}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </TabPane>
                    <TabPane tabId={3}>
                      <Table bordered responsive>
                        <thead
                          className="table-light"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <tr>
                            <th className="text-center">
                              องค์ประกอบการประเมิน
                            </th>

                            <th className="text-center">
                              คะแนน
                              <br />
                              (ก)
                            </th>
                            <th rowSpan="2" className="text-center">
                              สัดส่วนคะแนน
                              <br />
                              (น้ำหนัก) (ข)
                            </th>
                            <th rowSpan="2" className="text-center">
                              รวมคะแนน
                              <br />
                              (ก)x(ข)
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>{formTheeData_1.label}</td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {formTheeData_1.score}
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {formTheeData_1.percentage}%
                            </td>

                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {formTheeData_1.score !== "" ? (
                                <>
                                  {(
                                    (formTheeData_1.score *
                                      formTheeData_1.percentage) /
                                    100
                                  ).toFixed(4)}
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>{formTheeData_2.label}</td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {isNaN(formTheeData_2.score) ? "0.0000" : formTheeData_2.score}
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {formTheeData_2.percentage}%
                            </td>

                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {formTheeData_2.score !== "" ? (
                                <>
                                  {isNaN(((formTheeData_2.score * formTheeData_2.percentage) / 100).toFixed(4)) ? "0.0000" : ((formTheeData_2.score * formTheeData_2.percentage) / 100).toFixed(4)}
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </TabPane>
                    <TabPane tabId={4}>
                      <Table bordered responsive>
                        <thead
                          className="table-light"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <tr>
                            <th className="text-center">ลำดับ</th>
                            <th className="text-center">หัวข้อการพัฒนา</th>

                            <th colSpan={7} className="text-center">
                              การพัฒนาตนเอง
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formFourData.map(item => (
                            <tr key={item.id}>
                              <td
                                className="text-center"
                                style={{ width: "60px" }}
                              >
                                {item.id}
                              </td>
                              <td>
                                <DevelopmentTopicSelect
                                  onChange={e =>
                                    handleDevelopmentChange(
                                      item.id,
                                      "topic",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td
                                className="text-center"
                                style={{ width: "700px" }}
                              >
                                <Input
                                  style={{ height: "100px" }}
                                  type="textarea"
                                  placeholder="ระบุหลักสูตร/วิธีการ/แนวทางที่ต้องการ"
                                  value={item.description}
                                  onChange={e =>
                                    handleDevelopmentChange(
                                      item.id,
                                      "description",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </TabPane>
                    <Button className="me-2" color="warning" disabled={isUpdate} onClick={() => { setTask("DRAFT"); setconfirmModal(true); }}>
                      {isUpdate ? <SpinerSubmit /> : "บันทึกร่าง"}
                    </Button>
                    <Button color="success" onClick={handleClickSubmit} disabled={isSubmitting}>
                      {isSubmitting ? <SpinerSubmit /> : "ส่งแบบประเมิน"}
                    </Button>

                    {isUpdateSuccess === true && (
                      <span className="text-success pt-3 d-block">บันทึกร่างสำเร็จ</span>
                    )}

                    <Modal isOpen={isUpdateSuccess === false} toggle={() => setIsUpdateSuccess(null)} centered>
                      <ModalHeader toggle={() => setIsUpdateSuccess(null)} className="text-danger">
                        <i className="fa-solid fa-circle-exclamation me-2" />
                        บันทึกร่างไม่สำเร็จ
                      </ModalHeader>
                      <ModalBody>
                        เกิดข้อผิดพลาดในการบันทึกฉบับร่าง กรุณาลองใหม่อีกครั้ง
                      </ModalBody>
                      <ModalFooter>
                        <Button color="danger" onClick={() => setIsUpdateSuccess(null)}>ปิด</Button>
                      </ModalFooter>
                    </Modal>

                    <Col lg={12}>
                      <EvaLuateFormAlert
                        isFilledObjectArray={isFilledObjectArray}
                        EditGroup={groups}
                        countSumWeight={countSumWeight}
                        submitError={submitError}
                        setSubmitError={setSubmitError}
                      />
                    </Col>
                  </TabContent>
                </div>
                <div className="actions clearfix ms-2">
                  <ul>
                    <li style={{ cursor: activeTab === 1 ? "not-allowed" : "" }} className={`${activeTab === 1 ? "previous disabled" : "previous"} mt-2`}>
                      <Button disabled={activeTab === 1} color="primary" onClick={() => { toggleTab(activeTab - 1) }}>
                        ย้อนกลับ
                      </Button>
                    </li>
                    <li style={{ cursor: totalWeight < 100 ? "pointer" : activeTab === 4 ? "not-allowed" : "" }} className={`${activeTab === 4 ? "next disabled" : "next"} mt-2`}>
                      <Tooltip title={totalWeight < 100 ? "ต้องกรอกแบบประเมินผลสัมฤทธิ์ของงานและกรอกน้ำหนักร้อยละให้ครบ 100" : ""}>
                        <span>
                          <button
                            className="btn btn-primary"
                            disabled={nextButtonDisable}
                            color="primary" onClick={() => { toggleTab(activeTab + 1) }}>
                            ถัดไป
                          </button>
                        </span>
                      </Tooltip>
                    </li>
                  </ul>
                </div>
              </div>
            </CardBody>
          </Card>
          <ConfirmModal
            modal={confirmModal}
            modalSize="md"
            modalHeaderContent={
              task === "DRAFT" ? "ต้องการที่จะบันทึกฉบับร่างใช่ไหม"
                :
                task === "SUBMIT" ? "ต้องการที่จะส่งแบบประเมินให้"
                  :
                  task === "DELETE" ? `ลบลำดับที่ ${AcceptedgroupIndex + 1}`
                    : ""
            }
            taskName={task === "SUBMIT" ? nextLvApproveName : ""}
            onClickConfirmBtn={async () => {
              // await เพื่อให้ ConfirmModal ล็อกปุ่มยืนยันไว้จนกว่างานจะเสร็จจริง
              if (task === "DRAFT") {
                await handleDraft();
              } else if (task === "SUBMIT") {
                await handleSubmit();
              } else if (task === "DELETE") {
                handleRemoveGroup(AcceptedgroupIndex);
              }
              setconfirmModal(false)
            }}
            onClickCancelBtn={() => {
              setconfirmModal(false)
            }}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default EvaluateForm;